import { RouteConfig } from 'vue-router';

import store from '@/store/store';

export const viewAddRoute: RouteConfig = {
  path: 'add',
  name: 'viewAdd',
  meta: { breadcrumb: { title: 'Dodawanie' } },
  component: () => import(/* webpackChunkName: "ViewAdd" */ '@/views/mainRoute/view/Edit.vue'),
  beforeEnter: (to, from, next) => {
    Promise.all([store.dispatch('view/list', { count: -1 }), store.dispatch('schema/list', { count: -1 })]).then(() =>
      next()
    );
  }
};
